import { render, staticRenderFns } from "./Story2.vue?vue&type=template&id=c1f74ab4&scoped=true&lang=pug"
import script from "./Story2.vue?vue&type=script&lang=js"
export * from "./Story2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f74ab4",
  null
  
)

export default component.exports